class BreadcrumbList extends HTMLElement {
  constructor() {
    super();
    this.url = new URL(window.location.href);
  }

  connectedCallback() {
    this.host = this.url.host;

    this.hierarchyList = BuildPathHierarchyFromPathName(
      this.url.pathname,
      true,
    );

    this.urlList = BuildURLListFromHierarchyList(
      BuildPathHierarchyFromPathName(location.pathname, false),
      "/",
    );

    this.insertBreadcrumbList();
    this.buildBreadcrumbList();
  }

  insertBreadcrumbList() {
    const breadcrumbList = document.createElement("div");
    breadcrumbList.classList.add("breadcrumb-list");

    this.breadcrumbList = breadcrumbList;
    this.insertAdjacentElement("beforeend", breadcrumbList);
  }

  buildBreadcrumbList() {
    for (let i = 0; i < this.hierarchyList.length; i++) {
      const last = i == this.hierarchyList.length - 1;
      const currentName = this.hierarchyList[i];
      //not render pages in the breadcrumb UI
      if (currentName.toLowerCase() !== "pages" && currentName.toLowerCase() !== "blogs") {
        this.breadcrumbList.insertAdjacentHTML(
          "beforeend",
          `
        <div class="breadcrumb-list__item">
          <a
            href="${this.urlList[i]}"
            class="${`breadcrumb-list__item__link ${last ? " last" : ""}`}">
              ${currentName}
          </a>
          ${!last ? `<div class="vertical-sep">&gt;</div>` : ""}
        </div>
        `,
        );
      }
    }
  }
}

if (!customElements.get("breadcrumb-list")) {
  customElements.define("breadcrumb-list", BreadcrumbList);
}

function Dehandlize(str) {
  if (!str) return "";
  if (str === "/") return "Home";

  const acronyms = {
    faq: "FAQ",
    faqs: "FAQs"
  };

  const replaced = str.replace(/-/g, " ").toLowerCase();

  // If the whole string is an acronym
  if (acronyms[replaced]) return acronyms[replaced];

  // Title-case each word, preserving acronyms inside phrases
  return replaced
    .split(" ")
    .map(word => acronyms[word] || (word.charAt(0).toUpperCase() + word.slice(1)))
    .join(" ");
}

function BuildPathHierarchyFromPathName(pathname, dehandle) {
  const format = (data) => {
    if (dehandle) return Dehandlize(data);
    else return data;
  };

  const pathnameList = pathname.trim().split("/");

  if (CheckIfHomePage(pathname)) return [format(pathname)];
  else if (!pathnameList.length) return [];

  const hierarchyList = [format("/")];

  for (let i = 0; i < pathnameList.length; i++) {
    const path = pathnameList[i];

    if (path != "") {
      hierarchyList.push(format(path));
    }
  }

  return hierarchyList;
}

function CheckIfHomePage(handle) {
  if (handle == "" || handle == "/" || handle == "index") return true;
  else return false;
}

function BuildURLListFromHierarchyList(
  hierarchyList,
  baseUrl = "https://ttpottery.com/",
) {
  let hierarchy = "";
  let urlList = [];

  for (let i = 0; i < hierarchyList?.length; i++) {
    const isHomepage = CheckIfHomePage(hierarchyList[i]);
    const name = isHomepage ? "" : hierarchyList[i];

    hierarchy += `${name}`;

    urlList.push(`${baseUrl}${hierarchy}`);

    hierarchy += isHomepage ? "" : "/";
  }

  return urlList;
}

export {
  BuildURLListFromHierarchyList,
  BuildPathHierarchyFromPathName,
  CheckIfHomePage,
};
